import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StudentDetails } from '../models/Search/studentdetails';
import { SearchStudentByKeywordsRequest } from '../models/Requests/SearchStudentByKeywordsRequest.model';

@Injectable({
    providedIn: 'root'
})
export class StudentService {
    apiUrl: string = "Student";
    constructor(private http: HttpClient) {

    }

    searchStudentsByKeywords(searchRequest: SearchStudentByKeywordsRequest): Observable<any> {

        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(searchRequest);
        return this.http.post<any>(environment.baseUrl + this.apiUrl + '/SearchStudentByKeyword', body, { headers: headers }).pipe(map(data => {
            return data.body;
        }));
    }

    searchStudentsByCampus(searchRequest: SearchStudentByKeywordsRequest): Observable<any> {

        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(searchRequest);
        return this.http.post<any>(environment.baseUrl + this.apiUrl + '/SearchStudentByCampus', body, { headers: headers }).pipe(map(data => {
            return data.body;
        }));
    }
}
